
export class ClassificationExternalid {

  public id: string;
  public name: string;
  public classificationTypeId: string;
  public sortOrder: number;
  public sortDir: string;
  public items: any[];
  public value: string;
}
